module.exports = __webpack_public_path__ + "static/squ_ny_bg-7362a7112acfbffe2078cb0faabb5b0e.jpg";